// extracted by mini-css-extract-plugin
export var label = "_rn-0";
export var link = "_rn-1";